import React from "react";
import { motion } from "framer-motion";
import { FaGraduationCap } from "react-icons/fa";

const PrincipalDesk = () => {
  return (
    <section className="relative py-24 px-6 md:px-16 overflow-hidden bg-[#020810]">
      {/* Subtle cosmic background */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gold/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-12 gap-16 items-center">
          {/* ── Photo Section ── */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="lg:col-span-5 relative"
          >
            <div className="relative group">
              {/* Decorative Frame */}
              <div className="absolute -inset-4 border border-gold/20 rounded-2xl group-hover:border-gold/40 transition-colors duration-500" />
              <div className="absolute -inset-1 bg-gradient-to-tr from-gold/20 to-transparent blur-sm rounded-2xl" />

              {/* Main Image */}
              <div className="relative rounded-xl overflow-hidden shadow-2xl border border-white/10">
                <img
                  src="/renamed_website_images/principalmam.jpg"
                  alt="Principal Mrs. Vandana Prabhakar"
                  className="w-full h-auto object-cover object-top transform transition-transform duration-700 group-hover:scale-[1.02]"
                  style={{ maxHeight: "550px", objectPosition: "center 15%" }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#020810]/80 via-transparent to-transparent" />

                {/* Image Caption Overlay */}
                <div className="absolute bottom-6 left-6 right-6">
                  <h4 className="text-gold font-black uppercase tracking-widest text-sm mb-1">
                    Leadership Excellence
                  </h4>
                  <p className="text-white text-lg font-bold">
                    Mrs. Vandana Prabhakar
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* ── Message Section ── */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="lg:col-span-7"
          >
            <div className="relative">
              <span className="section-badge mb-6">Leadership Message</span>
              <h2
                className="text-4xl md:text-5xl font-black text-white mb-8 leading-tight"
                style={{ fontFamily: "Orbitron, sans-serif" }}
              >
                From the <span className="text-gold">Principal's</span> Desk
              </h2>

              <div className="space-y-6 text-gray-400 text-lg leading-relaxed">
                <p className="relative pl-8 border-l-2 border-gold/30">
                  <span className="absolute left-0 top-0 text-gold text-4xl opacity-50 font-serif">
                    "
                  </span>
                  I warmly welcome you to Galaxy Star Public School, where every
                  child is encouraged to dream big, think deeply, and grow into
                  confident, compassionate individuals.
                </p>
                <p>
                  Our dedicated team of educators works tirelessly to create an
                  environment that is safe, inclusive, and inspiring. We focus
                  not only on academic excellence but also on nurturing
                  creativity, critical thinking, and strong values.
                </p>
                <p>
                  At Galaxy Star, we see each child as a star in our galaxy —
                  bright, unique, and full of promise. Together with our parents
                  and community, we aim to shape young minds into responsible,
                  resilient individuals ready to lead with integrity and
                  kindness.
                </p>
              </div>

              {/* Official Seal / Signature */}
              <div className="mt-12 flex items-center gap-6 p-6 rounded-2xl bg-white/5 border border-white/10">
                <div className="w-16 h-16 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center text-gold">
                  <FaGraduationCap size={32} />
                </div>
                <div>
                  <p
                    className="text-white font-bold text-xl uppercase tracking-widest"
                    style={{ fontFamily: "Orbitron, sans-serif" }}
                  >
                    Vandana Prabhakar
                  </p>
                  <p className="text-gold font-medium uppercase tracking-widest text-xs">
                    Principal, Galaxy Star Public School
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PrincipalDesk;
